export default __webpack_public_path__ + "static/media/pageight.62eb3481.txt";